// src/utils/flowCompletionState.ts
import type { FlowId } from './frameFlowMap';
import { FLOW_COMPLETION_CONFIG } from './flowCompletionConfig';

export function isFlowEffectivelyComplete(args: {
  flowId: FlowId;
  session: unknown; // replace with your UserSession type
}): boolean {
  const { flowId, session } = args;

  const cfg = FLOW_COMPLETION_CONFIG[flowId];
  if (!cfg) {
    // Fallback: if you truly have flows without config, use your legacy logic,
    // but ideally every flow on Frame140/196 is in FLOW_COMPLETION_CONFIG.
    return session.completedTasks?.includes(flowId) ?? false;
  }

  const completeTaskId = cfg.completeTaskId;
  const isMarkedComplete = session.completedTasks?.includes(completeTaskId) ?? false;
  if (!isMarkedComplete) return false;

  const completionMeta = session.taskProgress?.[completeTaskId]?.completionMeta;
  const completionKind = completionMeta?.completionKind;

  // "Empty flow" completion should count as complete even when there's no meaningful data.
  const confirmedEmpty =
    completionMeta?.confirmedEmpty === true || completionKind === 'empty_flow';

  const hasMeaningful = cfg.hasMeaningfulData(session);

  // Completion is only valid if:
  // - flow has meaningful data, OR
  // - user explicitly confirmed empty completion (stored in completionMeta)
  return hasMeaningful || confirmedEmpty;
}